import GlossarySidebarList from "@/components/glossary/GlossarySlidebarList";
import Header from "@/components/header";
import Footer from "@/components/home/footer";
import Seo from "@/components/seo";
import { GlossaryList } from "@utils/glossaryList";
import Link from "next/link";
import React from "react";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const GlossaryItem = ({ glossary }) => {
  
  return (
    <>
      <Seo title={`${glossary.title} | Pinto Financial`} description={glossary.definition} />
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 mt-16">

        <div className="mt-14 flex justify-between">

         <GlossarySidebarList />
        
          <div>

            <div className="bg-white py-12 sm:py-12 ">
              <div className="px-0 sm:px-8">
                <div className="lg:mx-0">
                  <h2 className="text-4xl tracking-tight text-gray-900 sm:text-6xl">{glossary.title}</h2>
                  <p className="my-6 text-lg leading-8 text-gray-600">
                    {glossary.definition}  
                  </p>
                  <p>
                    {glossary.explanation.split("<br/>").map((paragraph, index) => (
                      <React.Fragment key={index}>
                        {paragraph}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>
                </div>
              </div>
            </div>

          </div>
        
        </div>
      </div>
     
     
      <Footer />
    </>
  );
};

export default GlossaryItem;

export async function getStaticPaths() {
  return {
    paths: GlossaryList.map((glossary) => ({
      params: {
        slug: glossary.slug,
      },
    })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const glossary = GlossaryList.filter((e) => e.slug == params.slug)[0];

  return {
    props: {
      glossary,
    },
    revalidate: 1,
  };
}
